"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const API_STATE = {
    INITIAL: 'INITIAL',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};
exports.default = API_STATE;
